import { render } from "./info-comp3.vue?vue&type=template&id=07398fa2&scoped=true"
import script from "./info-comp3.vue?vue&type=script&lang=js"
export * from "./info-comp3.vue?vue&type=script&lang=js"

import "./info-comp3.vue?vue&type=style&index=0&id=07398fa2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07398fa2"]])

export default __exports__